import { render, staticRenderFns } from "./users-filter.vue?vue&type=template&id=60d8b5e8"
import script from "./users-filter.vue?vue&type=script&lang=ts"
export * from "./users-filter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports